var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H36L14 40L20 20H8L18 0H32L24 14Z",
    fill: "url(#paint0_linear_78_241)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_241",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#995B44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyLogo);
export default __webpack_public_path__ + "static/media/Energy Logo.bfd19f8e2f09ff5c1040b937412e7f07.svg";
export { ForwardRef as ReactComponent };